import { useState } from 'react';
import { Image, Label, Tag, Text, Rect } from 'react-konva';
import useImage from 'use-image';
import config from "../etc/config.json";


function Rider(props) {
    const [image] = useImage(config.DIR_JERSEYS + props.image);
    const [hover, setHover] = useState(false);
    // const [hoverLeft, setHoverLeft] = useState(false);
    // const [hoverRight, setHoverRight] = useState(false);

    function handleHover(e, value, setter) {
        e.target.getStage().container().style.cursor = value ? 'pointer' : 'default';
        setter(value);
    }

    return <>
        <Image
            image={image} x={props.x} y={props.y}
            width={props.scale} height={props.scale}
        />
        {props.selectionMode === 'OwnRiderNoSelection' ? <>
            {hover ?
                <Text key={'overlaytext' + props.selectionMode + props.racer.rider.id}
                    text={'\uD83D\uDEE0'} align={'center'}
                    verticalAlign={'middle'}
                    x={props.x} y={props.y}
                    width={props.scale} height={props.scale}
                    fontSize={0.6 * props.scale}
                />
                : null}
            <Rect key={'overlay' + props.selectionMode + props.racer.rider.id}
                fill={hover ? '#ff0000' : '#000000'} opacity={hover ? 0.1 : 0.0}
                x={props.x} y={props.y}
                width={props.scale} height={props.scale}
                onMouseEnter={(e) => handleHover(e, true, setHover)}
                onMouseLeave={(e) => handleHover(e, false, setHover)}
                onClick={() => props.select(props.racer)}
                onTap={() => props.select(props.racer)}
            />
        </>
            : null}
        {props.selectionMode === 'OwnRiderSelected' ?
            <Rect key={'overlay' + props.selectionMode + props.racer.rider.id}
                fill={'#0000ff'} opacity={hover ? 0.3 : 0.1}
                style={{ cursor: hover ? 'pointer' : 'default' }}
                x={props.x} y={props.y}
                width={props.scale} height={props.scale}
                onMouseEnter={(e) => handleHover(e, true, setHover)}
                onMouseLeave={(e) => handleHover(e, false, setHover)}
                onClick={() => props.unselect(props.racer)}
                onTap={() => props.unselect(props.racer)}
            />
            : null}
        {props.selectionMode === 'OwnRiderSelectable' ?
            <Rect key={'overlay' + props.selectionMode + props.racer.rider.id}
                fill={'#ff0000'} opacity={hover ? 0.3 : 0.1}
                style={{ cursor: hover ? 'pointer' : 'default' }}
                x={props.x} y={props.y}
                width={props.scale} height={props.scale}
                onMouseEnter={(e) => handleHover(e, true, setHover)}
                onMouseLeave={(e) => handleHover(e, false, setHover)}
                onClick={() => props.selectTarget(props.racer)}
                onTap={() => props.selectTarget(props.racer)}
            />
            : null}
        {props.selectionMode === 'OwnRiderHelpedSelectable' ?
            <Rect key={'overlay' + props.selectionMode + props.racer.rider.id}
                fill={'#ff0000'} opacity={0.3}
                style={{ cursor: hover ? 'pointer' : 'default' }}
                x={props.x} y={props.y}
                width={props.scale} height={props.scale}
                onMouseEnter={(e) => handleHover(e, true, setHover)}
                onMouseLeave={(e) => handleHover(e, false, setHover)}
                onClick={() => props.selectTarget(props.racer)}
                onTap={() => props.selectTarget(props.racer)}
            />
            : null}
        {props.selectionMode === 'OtherRiderNoSelection' ?
            <>
                {hover ?
                    <Text key={'overlaytext' + props.selectionMode + props.racer.rider.id}
                        text={'i'} align={'center'}
                        fontStyle={'bold'}
                        verticalAlign={'middle'}
                        x={props.x} y={props.y}
                        width={props.scale} height={props.scale}
                        fontSize={0.6 * props.scale}
                    />
                    : null}
                <Rect key={'overlay' + props.selectionMode + props.racer.rider.id}
                    fill={'#0000ff'} opacity={hover ? 0.1 : 0.0}
                    style={{ cursor: hover ? 'pointer' : 'default' }}
                    x={props.x} y={props.y}
                    width={props.scale} height={props.scale}
                    onMouseEnter={(e) => handleHover(e, true, setHover)}
                    onMouseLeave={(e) => handleHover(e, false, setHover)}
                    onClick={() => props.info(props.racer.rider)}
                    onTap={() => props.info(props.racer.rider)}
                />
            </>
            : null}
        {props.selectionMode === 'OtherRiderSelectable' ?
            <Rect key={'overlay' + props.selectionMode + props.racer.rider.id}
                fill={'#00ff00'} opacity={hover ? 0.3 : 0.1}
                style={{ cursor: hover ? 'pointer' : 'default' }}
                x={props.x} y={props.y}
                width={props.scale} height={props.scale}
                onMouseEnter={(e) => handleHover(e, true, setHover)}
                onMouseLeave={(e) => handleHover(e, false, setHover)}
                onClick={() => props.selectTarget(props.racer)}
                onTap={() => props.selectTarget(props.racer)}
            />
            : null}
        {props.selectionMode === 'OtherRiderFollowedSelectable' ?
            <Rect key={'overlay' + props.selectionMode + props.racer.rider.id}
                fill={'#00ff00'} opacity={0.3}
                style={{ cursor: hover ? 'pointer' : 'default' }}
                x={props.x} y={props.y}
                width={props.scale} height={props.scale}
                onMouseEnter={(e) => handleHover(e, true, setHover)}
                onMouseLeave={(e) => handleHover(e, false, setHover)}
                onClick={() => props.selectTarget(props.racer)}
                onTap={() => props.selectTarget(props.racer)}
            />
            : null}
        <Label key={'riderNumber' + props.racer.rider.id} x={props.x + 0.1 * props.scale} y={props.y + 0.4 * props.scale}>
            <Tag fill="white" />
            <Text text={props.racer.number} fontSize={0.16 * props.scale} />
        </Label>
        <Label key={'riderName' + props.racer.rider.id} x={props.x} y={props.y + 0.85 * props.scale}>
            <Tag fill="white" />
            <Text text={props.racer.rider.lastNames.substring(0,8) + ' (' + props.racer.ownerAcronym + ')'} fontSize={0.14 * props.scale} />
        </Label>

    </>;


}

export default Rider;

